import app from "../_app";

const searchTriggers = [...document.querySelectorAll('.js-search-trigger')];
const search = document.querySelector('.js-search');
const header = document.querySelector('.js-header');
const headerInner = document.querySelector('.js-header-inner');
const inputField = document.querySelector('.js-search-input');

searchTriggers.map(searchTrigger => {
    searchTrigger.addEventListener('click', () => {
        if(search.getAttribute('data-open') === null) {
            search.setAttribute('data-open', '');
            headerInner.removeAttribute('data-transparent');
            header.querySelector('div:first-child').classList.remove('header--transparent');
            setTimeout(() => {
                document.querySelector(".js-search-input").focus();
            }, 100);

        }else {
            search.removeAttribute('data-open');
            headerInner.setAttribute('data-transparent', '');
            header.querySelector('div:first-child').classList.add('header--transparent');
        }
    });
})

if(search) {
    const searchInputs = [...search.querySelectorAll(".js-search-input")];
    const searchNavigations = [...document.querySelectorAll(".js-search-navigations")];
    const searchResultsCols = [...search.querySelectorAll(".js-search-results-col")];
    const searchCTA = search.querySelector(".js-search-results-cta");
    const noResultsContainer = search.querySelector(".js-search-results-none");
    const noResultsTerm = search.querySelector(".js-search-results-term");
    const searchResultsCollectionContainer = [...document.querySelectorAll(".js-search-results-collections")];
    const searchResultsProductContainer = [...document.querySelectorAll(".js-search-results-products")];
    const searchResultsPageContainer = [...document.querySelectorAll(".js-search-results-pages")];

    const handleSearchNavigation = (state = "show") => {
        searchNavigations.map(searchNavigation => {
            if (state === "hidden") {
                searchNavigation.setAttribute("data-hidden", "");
            } else if (state === "show") {
                searchNavigation.removeAttribute("data-hidden");
            }
        });
    };


    const resetResults = () => {
        handleSearchNavigation("show");
        noResultsContainer.removeAttribute("data-active");

        searchResultsCollectionContainer.map(resultsContainer => {
            resultsContainer.innerHTML = "";
            resultsContainer.parentNode.setAttribute('data-hidden', '');
        })

        searchResultsProductContainer.map(resultsContainer => {
            resultsContainer.innerHTML = "";
            resultsContainer.parentNode.setAttribute('data-hidden', '');
        })

        searchResultsPageContainer.map(resultsContainer => {
            resultsContainer.innerHTML = "";
            resultsContainer.parentNode.setAttribute('data-hidden', '');
        })

        searchCTA.setAttribute("href", "/search");
        searchCTA.removeAttribute("data-active");
        searchCTA.parentNode.removeAttribute("data-active");
    };

    const handleRequest = searchInput => {
        fetch(window.Shopify.routes.root + `search/suggest.json?q=${searchInput.value}&resources[type]=product,collection,page&resources[options][unavailable_products]=last&resources[options][fields]=author,body,product_type,tag,title,variants.barcode,variants.sku,variants.title,vendor`)
            .then((response) => response.json())
            .then((suggestions) => {
                const searchProductSuggestions = suggestions.resources.results.products;
                const searchCollectionSuggestions = suggestions.resources.results.collections;
                const searchPageSuggestions = suggestions.resources.results.pages;
                const searchResultsCount = [...search.querySelectorAll(".js-search-results-count")];
                const searchURL = window.Shopify.routes.root + `search?q=${searchInput.value}`;

                [...document.querySelectorAll('.js-search-results-cta')].map(cta => {
                    cta.setAttribute("href", searchURL);
                    cta.setAttribute("data-active", "");
                    cta.parentNode.setAttribute("data-active", "");
                });

                if (searchProductSuggestions.length > 0 || searchCollectionSuggestions.length > 0 || searchPageSuggestions.length > 0) {
                    // Search results
                    handleSearchNavigation("hidden");

                    /**
                     * Search results: Products
                     */
                    if (searchProductSuggestions.length > 0) {
                        searchResultsCols.map(searchResultsCol => {
                            if (searchResultsCol.hasAttribute("data-products")) {
                                searchResultsCol.removeAttribute("data-hidden");

                                searchResultsProductContainer.map(searchResultsContainer => {
                                    searchResultsContainer.innerHTML = "";
                                })

                            }
                        });

                        // Update search count
                        searchResultsCount.map(resultsCount => {
                            resultsCount.innerHTML = searchProductSuggestions.length;
                        });


                        [...searchResultsProductContainer].map(resultsContainer => {

                            let sliceAmount = 4;
                            if (app.viewport.isEqualOrGreaterThan('lg')) {
                                sliceAmount = 7;
                            }

                            searchProductSuggestions.slice(0, sliceAmount).map(product => {
                                const activeCurrency = window.Shopify.currency.active;
                                const activeCountry = window.Shopify.country;
                                const activeLocale = window.Shopify.locale;
                                const localeString = `${activeLocale}-${activeCountry}`;

                                const formattedPrice = parseFloat(product.price).toLocaleString(localeString, {
                                    style: "currency",
                                    currency: activeCurrency,
                                    minimumFractionDigits: 0
                                });

                                let discountPrice = product.compare_at_price_min;
                                if (parseFloat(discountPrice) !== 0) {
                                    discountPrice = parseFloat(discountPrice).toLocaleString(localeString, {
                                        style: "currency",
                                        currency: activeCurrency,
                                        minimumFractionDigits: 0
                                    });
                                } else {
                                    discountPrice = "";
                                }


                                const searchResultsProductDiv = document.createElement("a");
                                searchResultsProductDiv.setAttribute("href", product.url);
                                searchResultsProductDiv.classList.add("search-results__product-block");

                                let url = product.image;
                                let parts = url.split('?');
                                let imageUrl = parts[0];
                                let parameters = parts[1] || '';
                                let lastDotIndex = imageUrl.lastIndexOf('.');
                                let beforeExtension = imageUrl.substring(0, lastDotIndex);
                                let extension = imageUrl.substring(lastDotIndex);
                                let newImageUrl = `${beforeExtension}_90x90${extension}`;
                                if (parameters) {
                                    newImageUrl += `?${parameters}`;
                                }

                                searchResultsProductDiv.innerHTML = `
                                    <div class="search-results__product-image">
                                        ${product.image ? `<img src="${newImageUrl}" alt="${product.title}">` : ""}
                                    </div>

                                    <div class="search-results__product-details">
                                        <div class="search-results__product-title">
                                            ${product.title}
                                        </div>

                                        <div class="search-results__product-price">
                                            ${discountPrice && discountPrice !== 0 ? `<span class="search-results__product-price--old">${discountPrice}</span> ${formattedPrice}` : `${formattedPrice}`}
                                        </div>
                                    </div>
                                `;


                                resultsContainer.appendChild(searchResultsProductDiv);
                            });
                        });

                    } else {
                        // Hide products col
                        searchResultsCols.map(searchResultsCol => {
                            if (searchResultsCol.hasAttribute("data-products")) {
                                searchResultsCol.setAttribute("data-hidden", "");

                                searchResultsProductContainer.map(resultsContainer => {
                                    resultsContainer.innerHTML = '';
                                })
                            }
                        });
                    }

                    /**
                     * Search results: Collections
                     */
                    if (searchCollectionSuggestions.length > 0) {
                        searchResultsCols.map(searchResultsCol => {
                            if (searchResultsCol.hasAttribute("data-collections")) {
                                searchResultsCol.removeAttribute("data-hidden");
                                searchResultsCollectionContainer.map(resultsContainer => {
                                    resultsContainer.innerHTML = "";
                                })
                            }
                        });
                        searchResultsCollectionContainer.map(resultsContainer => {

                            searchCollectionSuggestions.map(collection => {
                                const searchResultsCollectionDiv = document.createElement("div");
                                searchResultsCollectionDiv.classList.add("search-results__collection-block");

                                searchResultsCollectionDiv.innerHTML = `
                                    <a href="${collection.url}">
                                        ${collection.title}
                                    </a>
                                `;

                                resultsContainer.appendChild(searchResultsCollectionDiv);
                            });
                        });

                    } else {
                        // Hide collections col
                        searchResultsCols.map(searchResultsCol => {
                            if (searchResultsCol.hasAttribute("data-collections")) {
                                searchResultsCol.setAttribute("data-hidden", "");
                                searchResultsCol.querySelector(".js-search-results-collections").innerHTML = "";
                            }
                        });
                    }

                    /**
                     * Search results: Pages
                     */
                    if (searchPageSuggestions.length > 0) {
                        searchResultsCols.map(searchResultsCol => {
                            if (searchResultsCol.hasAttribute("data-pages")) {
                                searchResultsCol.removeAttribute("data-hidden");

                                searchResultsPageContainer.map(resultsContainer => {
                                    resultsContainer.innerHTML = "";
                                })

                            }
                        });
                        searchResultsPageContainer.map(resultsContainer => {
                            searchPageSuggestions.map(page => {
                                const searchResultsCollectionDiv = document.createElement("div");
                                searchResultsCollectionDiv.classList.add("search-results__collection-block");

                                searchResultsCollectionDiv.innerHTML = `
                                    <a href="${page.url}">
                                        ${page.title}
                                    </a>
                                `;

                                resultsContainer.appendChild(searchResultsCollectionDiv);
                            })
                        });
                    } else {
                        // Hide pages col
                        searchResultsCols.map(searchResultsCol => {
                            if (searchResultsCol.hasAttribute("data-pages")) {
                                searchResultsCol.setAttribute("data-hidden", "");
                                searchResultsCol.querySelector(".js-search-results-pages").innerHTML = "";
                            }
                        });
                    }

                    noResultsContainer.removeAttribute("data-active");
                } else if (searchProductSuggestions.length === 0 && searchCollectionSuggestions.length === 0 && searchPageSuggestions.length === 0) {
                    noResultsContainer.setAttribute("data-active", "");
                    search.querySelector(".js-search-results-col[data-products]").setAttribute("data-hidden", "");
                    search.querySelector(".js-search-results-col[data-collections]").setAttribute("data-hidden", "");
                    search.querySelector(".js-search-results-col[data-pages]").setAttribute("data-hidden", "");

                    searchResultsCollectionContainer.map(resultsContainer => {
                        resultsContainer.innerHTML = "";
                    })

                    searchResultsProductContainer.map(resultsContainer => {
                        resultsContainer.innerHTML = "";
                    })

                    searchResultsPageContainer.map(resultsContainer => {
                        resultsContainer.innerHTML = "";
                    })

                    searchCTA.setAttribute("href", "/search");
                    searchCTA.removeAttribute("data-active");
                    searchCTA.parentNode.removeAttribute("data-active");
                    searchInput.focus();

                    const searchPageInput = document.querySelector(".js-searchpage-input");

                    if (searchPageInput) {
                        handleSearchNavigation("hidden");

                        noResultsTerm.innerHTML = searchPageInput.value;
                    }
                } else {
                    // No search results
                    handleSearchNavigation("hidden");
                }
            });
    };


    searchInputs.map(searchInput => {

        searchInput.addEventListener("keyup", () => {

            if (searchInput.value !== "" && searchInput.value) {
                if(noResultsTerm) {
                    noResultsTerm.innerHTML = searchInput.value;
                }

                handleRequest(searchInput);
            } else {
                searchResultsCols.map(searchResultsCol => {
                    searchResultsCol.setAttribute("data-hidden", "");

                    const productResultsContainer = searchResultsCol.querySelector(".js-search-results-products");
                    if (productResultsContainer) {
                        productResultsContainer.innerHTML = "";
                    }

                    const collectionResultsContainer = searchResultsCol.querySelector(".js-search-results-collections");
                    if (collectionResultsContainer) {
                        collectionResultsContainer.innerHTML = "";
                    }

                    const pageResultsContainer = searchResultsCol.querySelector(".js-search-results-pages");
                    if (pageResultsContainer) {
                        pageResultsContainer.innerHTML = "";
                    }
                });
                handleSearchNavigation("show");
                noResultsContainer.removeAttribute("data-active");
                searchCTA.setAttribute("href", "/search");
                searchCTA.removeAttribute("data-active");
                searchCTA.parentNode.removeAttribute("data-active");
            }
        });
    });

    [...document.querySelectorAll(".header-extensive-menu__button--search")].map(searchTrigger => {
        searchTrigger.addEventListener("click", (e) => {
            e.preventDefault();
            const headers = [...document.querySelectorAll(".js-header")];

            headers.map(header => {
                const searchOverlay = header.querySelector(".js-search");

                if (searchOverlay.classList.contains("header-overlay-search--active")) {
                    searchOverlay.classList.remove("header-overlay-search--active");
                    header.classList.remove("header--overlay-active");
                } else {
                    searchOverlay.classList.add("header-overlay-search--active");
                    header.classList.add("header--overlay-active");
                }
            });
        });
    });


    if (search.classList.contains("header__overlay--search")) {
        [...document.querySelectorAll(".js-searchpage-input")].map(input => {
            input.addEventListener("click", (e) => {
                e.stopPropagation();

                if (input.value && input.value !== '') {
                    [...document.querySelectorAll('.js-search-clear')].map(clearBtn => {
                        clearBtn.setAttribute('data-active', '');
                    })
                }

                const mediaQuery = window.matchMedia('(min-width: 1024px)');
                if (mediaQuery.matches) {
                    const desktopSearchTrigger = document.querySelector(".header-extensive-menu__button--search");
                    const desktopSearchInput = document.querySelector('.header-overlay-search__inner .js-search-input');
                    desktopSearchInput.value = input.value;
                    handleRequest(desktopSearchInput);
                    desktopSearchTrigger.click();
                } else {
                    const popupSearchInput = document.querySelector('.js-popup .js-search-input');
                    popupSearchInput.value = input.value;
                    handleRequest(popupSearchInput);
                    window.dispatchEvent(new Event('popup.toggle.general.search'));
                }
            });

            const clearBtn = document.querySelector(".js-searchpage-clear");

            if (input.value) {
                clearBtn.setAttribute("data-active", "");
            } else {
                clearBtn.removeAttribute("data-active");
            }

            input.addEventListener("keyup", () => {
                if (input.value) {
                    clearBtn.setAttribute("data-active", "");
                } else {
                    clearBtn.removeAttribute("data-active");
                }
            });

            clearBtn.addEventListener("click", () => {
                const desktopSearchTrigger = document.querySelector(".header-extensive-menu__button--search");
                input.innerHTML = "";
                input.value = "";

                clearBtn.removeAttribute('data-active');

                searchInputs.map(searchInput => {
                    searchInput.innerHTML = "";
                    searchInput.value = "";
                    resetResults();
                });

                desktopSearchTrigger.click();
            });
        });
    }

}
